import { render, staticRenderFns } from "./qulityEval.vue?vue&type=template&id=882e97dc&scoped=true"
import script from "./qulityEval.vue?vue&type=script&lang=js"
export * from "./qulityEval.vue?vue&type=script&lang=js"
import style0 from "./qulityEval.vue?vue&type=style&index=0&id=882e97dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882e97dc",
  null
  
)

export default component.exports